module.exports = __webpack_public_path__ + "img/BecomePan-1mob.fe0fcbd7.svg";